"use client";

import { useComponentTranslations, type BookingTranslationKey } from "@/app/components/LanguageProvider";
import BookingForm from "@/app/components/BookingForm";

export default function BookCallClient() {
    const { t: bookingT, translationsLoaded } = useComponentTranslations("Booking");

    const at = (key: BookingTranslationKey, fallback?: string) => {
        if (!translationsLoaded) return fallback ?? key;
        return bookingT(key, fallback) ?? fallback ?? key;
    };

    if (!translationsLoaded) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
            </div>
        );
    }

    return (
        <div className="mx-auto max-w-7xl px-4 py-24 text-white/90">
            <h1 className="text-3xl md:text-5xl font-bold text-center mb-8">
                {at("bookCallPageTitle")}
            </h1>
            <p className="text-center text-white/70 max-w-2xl mx-auto mb-12">
                {at("bookCallPageSubtitle")}
            </p>
            <div className="mx-auto max-w-lg">
                <BookingForm />
            </div>
        </div>
    );
}
